import { h } from "preact";

import { getRandomString } from "../../../foundation/utils/string";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAtom({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    const pathIds = {
        one: `IconAtom-${getRandomString()}`,
        two: `IconAtom-${getRandomString()}`
    };

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path={`url(${pathIds.one})`}>
                <g clip-path={`url(${pathIds.two})`}>
                    <path stroke={fill} stroke-width=".611" stroke-linecap="round" d="M12.698 4.295c.258-1.313.114-2.31-.496-2.706a1.213 1.213 0 0 0-.721-.18C10 1.467 7.609 3.507 5.656 6.514c-2.314 3.564-3.137 7.136-1.835 7.98.617.402 1.601.118 2.713-.675"/>
                    <path stroke={fill} stroke-width=".611" stroke-linecap="round" d="M13.886 10.124c1.098-.427 1.774-1.01 1.809-1.68.08-1.55-3.29-2.983-7.535-3.206-.397-.02-.789-.032-1.171-.03-3.7.012-6.587 1.027-6.66 2.43-.036.67.573 1.318 1.618 1.856"/>
                    <path stroke={fill} stroke-width=".611" stroke-linecap="round" d="M6.962 1.986c-.752-.623-1.457-.958-2.023-.916-.15.011-.29.049-.42.115-1.382.704-.94 4.347.989 8.133 1.929 3.787 4.614 6.285 5.996 5.58 1.33-.677.97-4.071-.775-7.698"/>
                    <path fill={fill} d="M8.977 8.15a.916.916 0 1 1-1.832 0 .916.916 0 0 1 1.832 0z"/>
                </g>
            </g>
            <defs>
                <clipPath id={pathIds.one}>
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
                <clipPath id={pathIds.two}>
                    <path fill="#fff" transform="translate(0 .7)" d="M0 0h16v14.656H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconAtom;
